(function () {
  function moveWhatsappToBody() {
    var wrap = document.querySelector(".rsport-whatsapp-wrap")
    if (!wrap) return

    if (wrap.parentElement !== document.body) {
      document.body.appendChild(wrap)
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", moveWhatsappToBody)
  } else {
    moveWhatsappToBody()
  }
})();

